import React from "react";
import { FaTimes } from "react-icons/fa";
import "./ResultPage.css";

const PaymentRequiredPopup = ({
  onClose,
  onProceedToPayment,
  onShowPreview,
}) => {
  return (
    <div className="result-popup-overlay" role="presentation">
      <div
        className="result-popup"
        role="dialog"
        aria-modal="true"
        aria-labelledby="payment-required-title"
      >
        <button
          type="button"
          className="result-popup-close"
          onClick={onClose}
          aria-label="Close payment popup"
        >
          <FaTimes />
        </button>
        <h2 id="payment-required-title" className="result-popup-title">
          Payment required
        </h2>
        <p className="result-popup-copy">
          Payment is required to see your full detailed result. Complete your
          payment to unlock the complete personality report, career path,
          strengths, challenges, and recommendations.
        </p>
        <div className="result-popup-actions">
          <button
            type="button"
            className="result-popup-primary"
            onClick={onProceedToPayment}
          >
            Proceed to payment
          </button>
          <button
            type="button"
            className="result-popup-secondary"
            onClick={onShowPreview}
          >
            Show sample report
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentRequiredPopup;
